import m, { useRef as d, useEffect as c, Component as h, createElement as f, createContext as E } from "react";
function C({
  remote: u,
  fallback: e
}) {
  return ({ ...o }) => {
    const r = d(null), n = d(
      null
    );
    return c(() => {
      let t = null;
      const s = setTimeout(() => {
        n.current || (n.current = u.default()), t = r.current, t && n.current.render({
          ...o,
          dom: t,
          fallback: e
        });
      });
      return () => {
        clearTimeout(s);
      };
    }, [o]), c(() => {
      let t = null;
      const s = setTimeout(() => {
        t = r.current;
      });
      return () => {
        var a;
        clearTimeout(s), t && ((a = n.current) == null || a.destroy({ dom: t }));
      };
    }, []), /* @__PURE__ */ m.createElement("div", { ref: r });
  };
}
const g = E(null), i = {
  didCatch: !1,
  error: null
};
class v extends h {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = i;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var o, r, n = arguments.length, t = new Array(n), s = 0; s < n; s++)
        t[s] = arguments[s];
      (o = (r = this.props).onReset) === null || o === void 0 || o.call(r, {
        args: t,
        reason: "imperative-api"
      }), this.setState(i);
    }
  }
  componentDidCatch(e, o) {
    var r, n;
    (r = (n = this.props).onError) === null || r === void 0 || r.call(n, e, o);
  }
  componentDidUpdate(e, o) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (r && o.error !== null && p(e.resetKeys, n)) {
      var t, s;
      (t = (s = this.props).onReset) === null || t === void 0 || t.call(s, {
        next: n,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(i);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: o,
      FallbackComponent: r,
      fallback: n
    } = this.props, {
      didCatch: t,
      error: s
    } = this.state;
    let a = e;
    if (t) {
      const l = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof o == "function")
        a = o(l);
      else if (r)
        a = f(r, l);
      else if (n !== void 0)
        a = n;
      else
        throw s;
    }
    return f(g.Provider, {
      value: {
        didCatch: t,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, a);
  }
}
function p() {
  let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return u.length !== e.length || u.some((o, r) => !Object.is(o, e[r]));
}
export {
  v as E,
  C as c
};
